module.exports = __webpack_public_path__ + "static/media/1-item-a.ff1cdae8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/1-item-a.jpg
// module id = 470
// module chunks = 33